import React from 'react';
import JudgeScoringPageRotation from './JudgeScoringPageRotation';

export default function BeamScoring() {
  return <JudgeScoringPageRotation apparatus="beam" />;
}
